export default {
  MAX_WIDTH: '535px'
}
